import { createProviderToken } from '@core/common-legacy';
import type { DynamicFormConfig } from '@tellent-ask-hr/dynamic-forms-types';

export const { inject: injectDynamicFormConfigs, provide: provideDynamicFormConfigs } =
  createProviderToken<new () => DynamicFormConfig>('DynamicFormConfig')(true);
